<app-header [secondaryLogoUrl]="partnerDetails?.partnerMedia?.logo"></app-header>

<div class="container-fluid background-gray">
    <div class="row" *ngIf="totalFoundOptions()">
        <div class="col-xs-12 col-md-8 col-md-offset-2">
            <div class="row">
                <div class="col-xs-12">
                    <p class="heading" id="congratulations">Here is the <span *ngIf="advanceEmiCount > 0">advance EMI</span> loan option for the
                        loan amount of ₹ {{requestedLoanAmount}}</p>
                </div>
                <div class="col-xs-12">
                    <p class="sub-heading">This is an indicative offer based on the information provided by you. The
                        final offer is based on documents submitted by you and the credit assessment done at finzy.</p>
                </div>

                <div class="col-xs-12">
                    <ng-container *ngFor="let option of defaultOptions">
                        <app-advance-emi-option-row class="option-row" [option]="option" [balanceAmount]="requestedLoanAmount - option.amount"
                                                     [advanceEmiCount]="advanceEmiCount"
                                                     (onApply)="applyForLoan($event)"></app-advance-emi-option-row>
                    </ng-container>
                </div>


                <div class="col-xs-12 mt-20px" *ngIf="partnerDetails.disbursalPreference !== 'borrower'">
                    <p class="sub-heading">
                        <b>NOTE:</b> The loan amount will be disbursed to <b>{{partnerDetails.partnerName}}</b>.<span
                            *ngIf="!isProcessingFeeSubvented()"> A one-time processing fee is charged at the time of loan disbursal.</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-md-8 col-md-offset-2">
            <p class="disclaimer">To check for different<span *ngIf="advanceEmiCount > 0">&nbsp;advance</span> EMI options, you can go back and alter the
                tenure. You can select the option to continue with the loan application flow. Final loan offer and<span *ngIf="advanceEmiCount > 0">&nbsp;advance</span> EMI amount will be communicated to you after a detailed credit decision.</p>
        </div>
    </div>

    <div class="row" *ngIf="!totalFoundOptions()">
        <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 bg-white px-5 py-3 mt-3 text-center">
            <p class="small-heading">We do not have any pre-approved offers for the selected tenure at the moment.</p>
            <p class="paragraph py-9 mb-3">
                However, you might be eligible for a pre-approved loan offer with a different tenure.<br/> Please <a class="hyperlink" (click)="backToPreviousPage()">go back</a> to select a different tenure.<br/>
                 If you are not eligible for any pre-approved offers, you can apply for a loan at <a class="hyperlink" target="_blank" [routerLink]="['/borrow']">finzy</a> directly, by filling up a quick loan application form and providing us with some more information and documents. We will get back to you with a decision within 24 working hours.

        </div>
    </div>


</div>
